// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"a684c16b","149":"241e6132","196":"c36cb962","823":"fdd11935"}[chunkId] + ".chunk.js";
};